export default __webpack_public_path__ + "static/media/Aura-Egg__72.00b3e679.png";